/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportBallTennisIcon16Light } from './SportBallTennisIcon16Light';
import { SportBallTennisIcon16Regular } from './SportBallTennisIcon16Regular';
import { SportBallTennisIcon16Solid } from './SportBallTennisIcon16Solid';
import { SportBallTennisIcon20Light } from './SportBallTennisIcon20Light';
import { SportBallTennisIcon20Regular } from './SportBallTennisIcon20Regular';
import { SportBallTennisIcon20Solid } from './SportBallTennisIcon20Solid';
import { SportBallTennisIcon24Regular } from './SportBallTennisIcon24Regular';
import { SportBallTennisIcon24Solid } from './SportBallTennisIcon24Solid';
import { SportBallTennisIcon32Regular } from './SportBallTennisIcon32Regular';
import { SportBallTennisIcon64Regular } from './SportBallTennisIcon64Regular';
var sizes = {
    16: {
        light: SportBallTennisIcon16Light,
        regular: SportBallTennisIcon16Regular,
        solid: SportBallTennisIcon16Solid,
    },
    20: {
        light: SportBallTennisIcon20Light,
        regular: SportBallTennisIcon20Regular,
        solid: SportBallTennisIcon20Solid,
    },
    24: {
        regular: SportBallTennisIcon24Regular,
        solid: SportBallTennisIcon24Solid,
    },
    32: {
        regular: SportBallTennisIcon32Regular,
    },
    64: {
        regular: SportBallTennisIcon64Regular,
    },
};
export var SportBallTennisIcon = forwardRef('SportBallTennisIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
